import { all, call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  GET_CORPORATE_DATA,
} from "../../Action/actionTypes";
import {
  getCorporateDataSuccess,
  getCorporateDataFailure,
} from "../../Action/corporate/getCorporateDataAction";

// Create a custom axios instance for user backend
const userBackendAPI = axios.create({
  baseURL: process.env.REACT_APP_USER_BACKEND_URL,
});

function* getCorporateDataRequest(action) {
  try {
    const { whiteLabelID, status } = action?.payload?.payload || {};
    let url = `/get-corporate-data`;
    let params = [];
    
    // Add whitelabel ID as query parameter if available
    if (whiteLabelID) {
      params.push(`whiteLabelID=${whiteLabelID}`);
    }
    
    // Add status as query parameter if available
    if (status) {
      params.push(`status=${status}`);
    }
    
    // Add query parameters to URL if any exist
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    
    const { data } = yield userBackendAPI.get(url);

    if (data?.meta?.code === 200) {
      yield put(getCorporateDataSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(getCorporateDataFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(getCorporateDataFailure());
  }
}

export function* watchGetCorporateDataAPI() {
  yield takeEvery(GET_CORPORATE_DATA, getCorporateDataRequest);
}

export default function* rootSaga() {
  yield all([watchGetCorporateDataAPI()]);
}